// extracted by mini-css-extract-plugin
export default {"action-column__content":"ActionsColumn_action-column__content__r2j7k"};